<template>
  <div class="px-24 py-16">
    <div class="mb-16">
      {{ $t('delete-account.select-reason-step.heading') }}
    </div>
    <el-form
      ref="form"
      :model="formValue"
      :rules="formRules"
    >
      <el-form-item
        prop="reason"
        @status="handleFormFieldStatusChange($event, 'reason')"
      >
        <el-select
          v-model="formValue.reason"
          :placeholder="$t('delete-account.select-reason-step.reason-label')"
          @change="validateComment"
        >
          <el-option
            v-for="reason in reasons"
            :key="reason.value"
            :label="reason.label"
            :value="reason.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item
        prop="comment"
        @status="handleFormFieldStatusChange($event, 'comment')"
      >
        <el-input
          v-model="formValue.comment"
          type="textarea"
          :label="$t('delete-account.select-reason-step.comment-label')"
        />
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
const ACCOUNT_DELETION_REASONS = [
  { label: 'delete-account.select-reason-step.reason.automatically-charged', value: 'I was automatically charged' },
  { label: 'delete-account.select-reason-step.reason.difficulties', value: 'I have difficulties using the software' },
  { label: 'delete-account.select-reason-step.reason.no-acronis-products', value: 'I don’t use Acronis products anymore' },
  { label: 'delete-account.select-reason-step.reason.new-account', value: 'I want to create a new account using a different email' },
  { label: 'delete-account.select-reason-step.reason.newsletters', value: 'I receive too many newsletters' },
  { label: 'delete-account.select-reason-step.reason.other', value: 'Other' }
];

export default {
name: 'SelectReasonStep',
emits: ['form-status-change', 'form-value-change'],
data() {
    return {
        formValue: {
            reason: '',
            comment: ''
        },
        formRules: {
          reason: {
            required: true,
            message: this.$t('form-error.required', { field: this.$t('delete-account.select-reason-step.reason-label') })
          },
          comment: [
            {
              validator: this.commentValidator
            },
            {
              max: 512,
              message: this.$t('delete-account.select-reason-step.comment.length-error') }
          ]
        },
        formStatus: {
          reason: false,
          comment: false
        },
        reasons: this.translateReasons(),
        formValid: false
    };
},
watch: {
  formStatus() {
    this.formValid = Object.keys(this.formStatus).every((input) => this.formStatus[input]);
    this.$emit('form-status-change', this.formValid);
  }
},
methods: {
    handleFormFieldStatusChange(change, field) {
      if (change.name === 'valid') {
        this.formStatus = { ...this.formStatus, [field]: change.value };
      }
    },
    translateReasons() {
        return ACCOUNT_DELETION_REASONS.map((reason) => (
          {
            label: this.$t(reason.label),
            value: reason.value
          }
        ));
    },
    commentValidator(_rule, value, callback) {
      if (this.formValue.reason === 'Other reason' && !value) {
        callback(new Error(`${this.$t('delete-account.select-reason-step.comment.required-error')}`));
      }
      callback();
    },
    validateComment() {
      this.$refs.form.validateField('comment', () => {
        // just trigger validation
      });
    }
 }
};
</script>
